import type { ServicesInsightsReportDto } from './ServicesInsightsReportDto';
import type { ServicesInsightsReport } from 'model/ServicesInsightsReport';

export const convertToServicesInsightsReport = (dto: ServicesInsightsReportDto): ServicesInsightsReport => {
    return {
        range: dto.range,
        totals: {
            quantity: Number(dto.totals?.quantity ?? 0),
            grossSales: Number(dto.totals?.gross_sales ?? 0),
            discounts: Number(dto.totals?.discounts ?? 0),
            refunds: Number(dto.totals?.refunds ?? 0),
            netSales: Number(dto.totals?.net_sales ?? 0),
            allNetSales: Number(dto.totals?.all_net_sales ?? 0)
        },
        meta: {
            page: Number(dto.meta?.page ?? 1),
            perPage: Number(dto.meta?.per_page ?? 25),
            totalCount: Number(dto.meta?.total_count ?? 0),
            totalPages: Number(dto.meta?.total_pages ?? 0)
        },
        services: (dto.services ?? []).map(r => ({
            serviceId: String(r.service_id),
            serviceName: r.service_name ?? null,
            categoryId: r.category_id ?? null,
            category: r.category ?? null,

            quantity: Number(r.quantity ?? 0),
            avgPrice: Number(r.avg_price ?? 0),
            grossSales: Number(r.gross_sales ?? 0),
            discounts: Number(r.discounts ?? 0),
            refunds: Number(r.refunds ?? 0),
            netSales: Number(r.net_sales ?? 0),

            netServicesSalesPct: Number(r.net_services_sales_pct ?? 0),
            allNetSalesPct: Number(r.all_net_sales_pct ?? 0)
        }))
    };
};
